class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[name="q"]');
    this.predictiveSearchResults = this.querySelector('[data-ref="predictive-search"]');

    this.input.addEventListener(
      'input',
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this),
    );

    this.predictiveSearchResults.addEventListener('click', (event) => {
      // Navibreizhshop : croix de fermeture de la fenêtre de suggestions
      if (event.target.closest('[data-predictive-close]')) {
        this.hide();
        return;
      }

      const tabButton = event.target.closest('[data-predictive-tab]');
      if (!tabButton) return;
      this.switchTab(tabButton.dataset.predictiveTab);
    });

    // Navibreizhshop : la touche Échap ferme les suggestions de la barre de recherche du header
    if (this.hasAttribute('data-header-predictive-search')) {
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.hide();
      });
    }
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.hide();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    // Navibreizhshop : jusqu'à 10 propositions par type (produits, collections, pages, articles)
    // au lieu de 10 au total. 10 est le maximum accepté par la recherche prédictive de Shopify.
    fetch(Theme.routes.predictive_search_url + `?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search&resources[type]=product,collection,page,article&resources[limit]=10&resources[limit_scope]=each`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.hide();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.loadCompare();
        this.show();
      })
      .catch((error) => {
        this.hide();
        throw error;
      });
  }

  // Navibreizhshop : charge le comparateur (assets/product-compare.js) quand les suggestions
  // contiennent des cases « Comparer » et que la page ne l'a pas déjà chargé
  loadCompare() {
    if (this.compareRequested || customElements.get('product-compare-toggle')) return;

    const url = this.predictiveSearchResults.querySelector('[data-compare-script]')?.dataset.compareScript;
    if (!url) return;

    this.compareRequested = true;
    import(new URL(url, document.baseURI).href).catch(() => {
      this.compareRequested = false;
    });
  }

  switchTab(tabName) {
    const root = this.predictiveSearchResults;

    root.querySelectorAll('[data-predictive-tab]').forEach((button) => {
      const isActive = button.dataset.predictiveTab === tabName;
      button.classList.toggle('active', isActive);
      button.setAttribute('aria-selected', String(isActive));
    });

    root.querySelectorAll('[data-predictive-panel]').forEach((panel) => {
      panel.classList.toggle('is-hidden', panel.dataset.predictivePanel !== tabName);
    });
  }

  show() {
    this.predictiveSearchResults.style.display = 'block';
  }

  hide() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
